import React from 'react'

const Loading = () => (
  <React.Fragment>
    <i className="fa fa-spinner fa-pulse fa-3x fa-fw" />
    <span className="sr-only">Loading...</span>
  </React.Fragment>
)

export default Loading



// WEBPACK FOOTER //
// ./src/utils/Loading.js